export const GradeList = [
    '幼儿园小班',
    '幼儿园中班',
    '幼儿园大班',
    '小学一年级',
    '小学二年级',
    '小学三年级',
    '小学四年级',
    '小学五年级',
    '小学六年级',
    '初中一年级',
    '初中二年级',
    '初中三年级',
    '高中一年级',
    '高中二年级',
    '高中三年级',
    '毕业'
]

export default class Grade {
    /** 系统年级编号 */
    grade

    /** 年级默认标签 */
    get label () {
        if (this.grade > 0 && this.grade < 17) {
            return GradeList[this.grade - 1]
        }
        return undefined
    }

    constructor (data = {}) {
        this.grade = data.grade
    }
}
